<template>
    <div v-if="table.cellConfigs" :class="rowClasses" v-on="$listeners" @mouseover="onMouseOver" @mouseleave="onMouseLeave">
        <slot name="status-indicator" />
        <master-table-cell-selection v-model="item.selected" :rowId="id" @change.native="toggleItem" />
        <master-table-cell-ghost v-for="(cellConfig, index) in table.cellConfigs" :key="table.cellConfigs[index].id" :cellConfig="table.cellConfigs[index]">
            <slot name="master-table-cell" />
            <slot />
        </master-table-cell-ghost>
        <div v-if="item.deleting" class="delete-overlay"></div>
        <master-table-row-options v-if="(!multiselector && !selector && hover && options) || item.deleting" :options="options" :item="item" />
    </div>
</template>

<script>
import MasterTableCellGhost from '@/components/master-table/master-table-cell-ghost';
import MasterTableCellSelection from '@/components/master-table/master-table-cell-selection';

export default {
    name: 'MasterTableRow',

    components: {
        'master-table-cell-ghost': MasterTableCellGhost,
        'master-table-cell-selection': MasterTableCellSelection
    },

    inject: ['table'],

    props: {
        id: [Number, String],
        item: [Array, Object],
        disabled: Boolean,
        options: {
            type: Array
        },
        selector: {
            type: Boolean,
            default: false
        },
        multiselector: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hover: false,
        }
    },

    computed: {
        rowClasses() {
            return {
                'selected': this.item.selected,
                'selector': this.selector,
                'multiselector': this.multiselector,
                'deleting': this.item.deleting,
                'disabled': this.disabled,
                'master-table-row': true,
                'row': true
            }
        },
    },

    created() {
        if (!this.table.hasLoadedInitialConfig) {
            this.setCellConfigs();
        }
    },

    methods: {
        onMouseOver(){
            this.hover = true;   
        },

        onMouseLeave() {
            this.hover = false;
        },

        toggleItem() {
            this.$emit('itemToggled', this.item);
        },

        createCellConfig(cellProps) {
            return {
                id: cellProps.id,
                label: cellProps.label,
                sortBy: cellProps.sortBy,
                classes: cellProps.classes,
                isVisible: true
            };
        },

        createCellConfigs() {
            var slots = this.$slots['master-table-cell'];

            var cellConfigs = Array
                .from(slots)
                .filter(cell => {
                    const isTableCell = cell.componentOptions.tag && cell.componentOptions.tag === 'master-table-cell';
                    var hasContext = cell.context;
                    
                    return isTableCell && hasContext;
                })
                .map((cell, index) => {
                    const cellProps = cell.componentOptions.propsData;
        
                    cellProps.id = index;

                    return this.createCellConfig(cellProps);
                });

            return cellConfigs;
        },

        sortAndShowBySaved(cellConfigs) {
            var sorted = [];

            for (var i = 0; i < this.table.initialCellConfigs.length; i++) {
                var savedConfig = this.table.initialCellConfigs[i];

                var matchingCellConfig = cellConfigs.filter(config => { return config.label === savedConfig.label; })[0];
                if (matchingCellConfig) {
                    if (typeof savedConfig.isVisible !== 'undefined') {
                        matchingCellConfig.isVisible = savedConfig.isVisible;
                    }

                    sorted.push(matchingCellConfig);
                }
            }

            return sorted;
        },

        isSavedConfigValid(cellConfigs) {
            try {
                return this.table.initialCellConfigs
                    && cellConfigs.every(config => this.table.initialCellConfigs.some(saved => saved && saved.label === config.label));
            }
            catch {
                return false;
            }
        },

        setCellConfigs() {
            var cellConfigs = this.createCellConfigs();

            if (this.isSavedConfigValid(cellConfigs)) {
                cellConfigs = this.sortAndShowBySaved(cellConfigs);
            }

            this.table.hasLoadedInitialConfig = true;
            this.table.cellConfigs = cellConfigs;
        }
    },
}
</script>

<style scoped>
.table .master-table-row {
    display: inline-flex;
    background: #FFFFFF;
    border-top: 1px solid #EEEEEE;
    padding-left: 0;
    min-height: 52px;
    min-width: 100%;
    vertical-align: bottom;
}

.table .master-table-row.selected {
    background-color: var(--color-fill-cell-selected); /* mass replace;*/
}

.table .master-table-row.disabled {
    background-color: #E9E9EF;
}

.table .master-table-row:hover {
    background: #DEF4FF;
}

.table .master-table-row:nth-child(1) {
    border: none;
}

.table .master-table-row .delete-overlay {
    background: rgba(245, 213, 231, .8);
    width: 100%;
    height: 52px;
    position: absolute;
    z-index: 2;
}

.master-table.items-selected .master-table-row-options,
.master-table .master-table-row.disabled .master-table-row-options {
    display: none;
}
</style>
